var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOrgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2424_55705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 5.11111V2H2V16H17V5.11111H9.5ZM5 14.4444H3.5V12.8889H5V14.4444ZM5 11.3333H3.5V9.77778H5V11.3333ZM5 8.22222H3.5V6.66667H5V8.22222ZM5 5.11111H3.5V3.55556H5V5.11111ZM8 14.4444H6.5V12.8889H8V14.4444ZM8 11.3333H6.5V9.77778H8V11.3333ZM8 8.22222H6.5V6.66667H8V8.22222ZM8 5.11111H6.5V3.55556H8V5.11111ZM15.5 14.4444H9.5V12.8889H11V11.3333H9.5V9.77778H11V8.22222H9.5V6.66667H15.5V14.4444ZM14 8.22222H12.5V9.77778H14V8.22222ZM14 11.3333H12.5V12.8889H14V11.3333Z",
    fill: "#DCE0E4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2424_55705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOrgDashboard);
export default __webpack_public_path__ + "static/media/iconOrgDashboard.d36dcdd4479bfebd8a47699a5f06256e.svg";
export { ForwardRef as ReactComponent };